import { createRouter, createWebHistory } from '@ionic/vue-router';

import routes from './routes';
import authGuard from '@/middleware/auth';
import unAuthGuard from '@/middleware/unAuth';
import maintenanceGuard from '@/middleware/maintenance';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  await maintenanceGuard({ to, next });

  if (to.meta.requiresAuth) {
    authGuard({ to, from, next });
  } else if (to.meta.requiredUnauth) {
    unAuthGuard({ to, from, next });
  } else {
    next();
  }
});
export default router;
